// extracted by mini-css-extract-plugin
module.exports = {"ReviewCard":"ReviewCard","bluePoint":"bluePoint","IteamCount":"IteamCount","titleBtnBox":"titleBtnBox","loadingCenterPos":"loadingCenterPos"};